import * as React from 'react';
import { NumberInput } from 'react-admin';
import { useFormState } from 'react-final-form';
import { describePeriod } from './noticeApi';

/**
 * The notice period, in days, with the equivalent in weeks underneath when it
 * is a whole number of weeks. Must be rendered inside a react-admin form.
 */
export const NoticePeriodInput = (props) => {
    const { values } = useFormState({ subscription: { values: true } });
    const label = describePeriod(values?.notice_period_days);

    return (
        <NumberInput
            source="notice_period_days"
            label="Notice period (days)"
            fullWidth
            helperText={
                label
                    ? `${label} before the end date. Notice is emailed to the crew member then.`
                    : 'Days before the end date that notice is given. 7 unless changed.'
            }
            {...props}
        />
    );
};

export default NoticePeriodInput;
